<template>
    <section id="storeList" class="py-10 xl:pt-[120px] xl:pb-[60px] relative will-change" :data-scroll-section="inner == 'false'">
        <div class="px-content mb-12">
            <h2 class="text-4xl xl:text-heading mb-8" v-show="blockData.title">{{ blockData.title }}</h2>
        <!-- <div v-show="blockData.text" v-html="blockData.text"></div> -->
        </div>

        <!-- filter -->
        <div class="filter-wrap px-content flex flex-col-reverse xl:flex-row items-center mb-10">

            <div class="flex items-center overflow-x-auto w-full">
                <!-- <div class="toponym-swiper swiper-container" ref="sliderModal">
                    <div class="swiper-wrapper">
                        <div v-for="( slide, index ) in activeStore.data.fields.gallery" :key="index" class="swiper-slide self-stretch relative flex flex-col" >
                            <img class="object-cover w-full" :src="slide.sizes.toponymslide" :alt="slide.alt">
                        </div>
                    </div>
                </div> -->

                <button type="button" class="btn-filter whitespace-nowrap" @click="activeCategory = false; updateScroll();" :class="{'active' : !activeCategory}">{{ __('All Stores', 'ccave') }}</button>
                <button type="button" class="btn-filter whitespace-nowrap" v-show="categories" v-for="cat in categories" :key="cat.id" @click="activeCategory = cat; updateScroll();" :class="{'active' : activeCategory === cat}" v-html="cat.name"></button>
            </div>

            <!-- search -->
            <div class="flex items-center border-b border-light-grey mb-8 xl:mb-0 xl:ml-auto py-2 w-full xl:w-[23.88%] ">
                <svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.25003 2.39961C4.57145 2.39961 2.40003 4.57103 2.40003 7.24961C2.40003 9.92819 4.57145 12.0996 7.25003 12.0996C9.92861 12.0996 12.1 9.92819 12.1 7.24961C12.1 4.57103 9.92861 2.39961 7.25003 2.39961ZM1.60003 7.24961C1.60003 4.1292 4.12962 1.59961 7.25003 1.59961C10.3704 1.59961 12.9 4.1292 12.9 7.24961C12.9 10.37 10.3704 12.8996 7.25003 12.8996C4.12962 12.8996 1.60003 10.37 1.60003 7.24961Z" fill="#BFBFBF"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6792 10.6797C10.8354 10.5234 11.0887 10.5234 11.2449 10.6797L14.2824 13.7172C14.4386 13.8734 14.4386 14.1267 14.2824 14.2829C14.1262 14.4391 13.873 14.4391 13.7168 14.2829L10.6792 11.2453C10.523 11.0891 10.523 10.8359 10.6792 10.6797Z" fill="#BFBFBF"/>
                </svg>
                <input class="border-none focus:outline-none" type="text" v-model="searchQuery" :placeholder="getSearchString()" />
            </div>
            <!-- ./search -->
        </div>

        <!-- card list -->
        <div class="px-content grid md:grid-cols-2 xl:grid-cols-4 gap-5 xl:gap-6 xl:gap-y-10">
            <div class="card-toponyms bg-white" v-show="stores" v-for="(store, index) in filteredStores" :key="index">
                <div class="overflow-hidden relative" >
                    <img class="object-cover w-full" v-show="store.data.fields.image" :src="store.data.fields.image.url" :alt="store.data.fields.image.alt">
                </div>
                <div class="card-toponyms__txt ">
                    <div class="picto picto-toponyms mb-5">
                        <img v-show="store.data.fields.iconlogo" :src="store.data.fields.iconlogo.url" :alt="store.data.fields.iconlogo.alt">
                    </div>
                    <h4 class="font-ginger font-medium text-2xl tracking-[1px] mb-1" v-show="store.title.rendered" v-html="store.title.rendered"></h4>
                    <div class="mb-8 text-sm" v-show="store.neighbourhood">{{ getNeigbourhoodName(store.neighbourhood[0]) }}</div>
                    <div class="text-sm mb-10" v-show="store.data.fields.text" v-html="store.data.fields.text"></div>
                    

                    <div class="social-links flex items-center mt-auto">
                        <a class="mr-1" v-if="store.data.fields.instagram" :href="store.data.fields.instagram" target="_blank">
                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9999 10.3248C11.9703 10.3248 10.3249 11.9702 10.3249 13.9998C10.3249 16.0295 11.9703 17.6748 13.9999 17.6748C16.0296 17.6748 17.6749 16.0295 17.6749 13.9998C17.6749 11.9702 16.0296 10.3248 13.9999 10.3248ZM8.92493 13.9998C8.92493 11.197 11.1971 8.9248 13.9999 8.9248C16.8028 8.9248 19.0749 11.197 19.0749 13.9998C19.0749 16.8026 16.8028 19.0748 13.9999 19.0748C11.1971 19.0748 8.92493 16.8026 8.92493 13.9998Z" fill="#001E31"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.18743 4.6373C6.67453 4.6373 4.63743 6.67441 4.63743 9.1873V18.8123C4.63743 21.3252 6.67453 23.3623 9.18743 23.3623H18.8124C21.3253 23.3623 23.3624 21.3252 23.3624 18.8123V9.1873C23.3624 6.67441 21.3253 4.6373 18.8124 4.6373H9.18743ZM3.23743 9.1873C3.23743 5.90121 5.90133 3.2373 9.18743 3.2373H18.8124C22.0985 3.2373 24.7624 5.90121 24.7624 9.1873V18.8123C24.7624 22.0984 22.0985 24.7623 18.8124 24.7623H9.18743C5.90133 24.7623 3.23743 22.0984 3.23743 18.8123V9.1873Z" fill="#001E31"/>
                                <path d="M19.6875 9.625C20.4124 9.625 21 9.03738 21 8.3125C21 7.58763 20.4124 7 19.6875 7C18.9626 7 18.375 7.58763 18.375 8.3125C18.375 9.03738 18.9626 9.625 19.6875 9.625Z" fill="#001E31"/>
                            </svg>
                        </a>
                        <a class="mr-1" v-if="store.data.fields.facebook" :href="store.data.fields.facebook" target="_blank">
                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5763 2.84804V6.56686H17.6304C16.0805 6.56686 15.8597 7.07212 15.8597 8.07126V10.2835H15.8598V8.07132C15.8598 7.07218 16.0806 6.56692 17.6305 6.56692H19.5764V2.84804H19.5763ZM19.5763 10.2835L19.1325 14.0001H15.8574V25.1522H11.0371V25.1522H15.8575V14.0001H19.1326L19.5764 10.2835H19.5763ZM11.037 14.0001V14.0001H8.42434V14.0001H11.037ZM8.20129 14.2232H10.8141V25.3753H16.0806V14.2232H19.3306L19.8277 10.0605H16.0829V8.07132C16.0829 7.5712 16.1433 7.28216 16.3224 7.10144C16.5035 6.91861 16.8638 6.78996 17.6305 6.78996H19.7995V2.625H16.3287C14.3105 2.625 12.9165 3.08694 12.0313 3.99535C11.1468 4.90294 10.8141 6.21157 10.8141 7.80275V10.0605H8.20129V14.2232ZM14.929 11.2143V11.2144H18.5294L18.5294 11.2143H15.9212H14.929ZM18.6477 3.77662H16.3309C14.6763 3.77662 13.5202 4.09753 12.8692 4.79397C12.282 5.41075 11.968 6.38029 11.968 7.80275V11.2098H9.35519V13.0692H9.35509V11.2098H11.103H11.9679V10.2516V7.80269C11.9679 6.38023 12.2819 5.41069 12.8691 4.79391C13.5201 4.09747 14.6762 3.77656 16.3308 3.77656H18.6477V3.77662ZM11.9679 13.0693V13.9705V24.2236H11.968V13.0693H11.9679ZM14.7059 11.4374H18.2787L18.1127 12.8485H14.7082V24.0006H12.191V12.8462H9.57824V11.4329H12.191V7.80275C12.191 6.40788 12.4996 5.50566 13.0308 4.94776L13.0322 4.94627C13.6169 4.32065 14.6908 3.99967 16.3309 3.99967H18.4248V5.41302H17.6305C16.9407 5.41302 15.9403 5.46951 15.3094 6.16736C14.781 6.75442 14.7059 7.46994 14.7059 8.06449V11.4374Z" fill="#001E31"/>
                            </svg>
                        </a>
                        <a class="mr-1" v-if="store.data.fields.cta" :href="store.data.fields.cta.url" target="_blank">
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.49974 4.08393C6.35104 5.07731 4.01312 7.89723 3.72891 11.3008H7.56118C7.63365 9.08381 8.04886 7.06338 8.70468 5.53204C8.93467 4.99502 9.19984 4.50505 9.49974 4.08393ZM14.4999 4.08393C14.7998 4.50505 15.0649 4.99502 15.2949 5.53204C15.9508 7.06338 16.366 9.08381 16.4384 11.3008H20.2707C19.9865 7.89723 17.6486 5.07731 14.4999 4.08393ZM15.0376 11.3008C14.9655 9.23914 14.5776 7.41319 14.008 6.08319C13.6909 5.34275 13.3313 4.78829 12.9676 4.42913C12.6069 4.07292 12.2807 3.94297 11.9998 3.94297C11.7189 3.94297 11.3927 4.07292 11.032 4.42913C10.6684 4.78829 10.3087 5.34275 9.99163 6.08319C9.42203 7.41319 9.0341 9.23914 8.96197 11.3008H15.0376ZM8.96208 12.7008H15.0375C14.9651 14.7611 14.5773 16.5859 14.008 17.9152C13.6909 18.6557 13.3313 19.2101 12.9676 19.5693C12.6069 19.9255 12.2807 20.0555 11.9998 20.0555C11.7189 20.0555 11.3927 19.9255 11.032 19.5693C10.6684 19.2101 10.3087 18.6557 9.99163 17.9152C9.42232 16.5859 9.03449 14.7611 8.96208 12.7008ZM7.56128 12.7008H3.72891C4.01321 16.1054 6.35246 18.926 9.50261 19.9185C9.20153 19.4965 8.9354 19.0051 8.70468 18.4664C8.04917 16.9358 7.63404 14.9165 7.56128 12.7008ZM14.497 19.9185C14.7981 19.4965 15.0642 19.0051 15.2949 18.4664C15.9504 16.9358 16.3656 14.9165 16.4383 12.7008H20.2707C19.9864 16.1054 17.6471 18.926 14.497 19.9185ZM11.9998 2.30078C6.64264 2.30078 2.2998 6.64362 2.2998 12.0008C2.2998 17.3579 6.64264 21.7008 11.9998 21.7008C17.357 21.7008 21.6998 17.3579 21.6998 12.0008C21.6998 6.64362 17.357 2.30078 11.9998 2.30078Z" fill="black"/>
                            </svg> 
                        </a>

                    </div>

                    <!-- <a class="btn self-start mt-auto whitespace-pre-line" v-if="store.data.fields.cta" :href="store.data.fields.cta.url" target="_blank" >{{store.data.fields.cta.title}}
                        <svg class="ml-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 12L21 12" stroke="#405664" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round" />
                            <path d="M18 8L22 12L18 16" stroke="#405664" stroke-width="1.2" stroke-linecap="square" />
                        </svg>
                    </a> -->
                </div>
            </div>

        </div>
        <!-- <ModalWindow
			:visible="showModal"
			:close-on-escape="true"
			:close-on-outside-click="true"
			:show-x-mark="true"
			@close="showModal = false"
		>
             <div v-if="activeStore">
                <img class="object-cover w-full" :src="activeStore.data.fields.image.sizes.customslide" :alt="activeStore.data.fields.image.alt">

                <div class="p-8">
                    <h4 class="text-2xl tracking-[1px] mb-6" >{{ activeStore.title.rendered }}</h4>
                    <div class="text-sm" v-html="activeStore.data.fields.text"></div>
                </div>

                <div v-show="activeStore.neighbourhood">
                    <dt class="tracking-desk text-sm leading-tight uppercase mb-6">LOCATION</dt>
                        <dd class="flex">
                            <div>
                                <svg class="mr-4" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z"
                                        stroke="#405664" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z"
                                        stroke="#405664" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div>{{ getNeigbourhoodName(activeStore.neighbourhood[0]) }}</div>
                        </dd>
                </div>

                <div v-show="activeStore.data.fields.work_hours">
                    <dt class="tracking-desk text-sm leading-tight uppercase mb-6">WORK HOURS</dt>
                        <div class="group inline-block border rounded-sm relative">
                            <button class="flex flex-col bg-gray-300 text-gray-700 font-semibold py-2 px-4 w-full">
                                <div class="flex items-center w-full">
                                    <span id="hours-title" class="mr-1 text-sm py-[5px]">{{ getStatus() }}</span><span v-show="activeDayHours.openedclosed">{{ getDay() }}</span>
                                    <svg class="fill-current h-4 w-4 ml-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                    </svg>
                                </div>
                            </button>
                            <ul class="bg-white absolute hidden group-hover:block ">
                                <li v-if="isOpen(0)" class="">Monday: {{ formatTime(activeStore.data.fields.work_hours[0].open) }} - {{ formatTime(activeStore.data.fields.work_hours[0].close) }}</li><li v-else>Monday: Closed</li>
                                <li v-if="isOpen(1)" class="">Tuesday: {{ formatTime(activeStore.data.fields.work_hours[1].open) }} - {{ formatTime(activeStore.data.fields.work_hours[1].close) }}</li><li v-else>Tuesday: Closed</li>
                                <li v-if="isOpen(2)" class="">Wednesday: {{ formatTime(activeStore.data.fields.work_hours[2].open) }} - {{ formatTime(activeStore.data.fields.work_hours[2].close) }}</li><li v-else>Wednesday: Closed</li>
                                <li v-if="isOpen(3)" class="">Thursday: {{ formatTime(activeStore.data.fields.work_hours[3].open) }} - {{ formatTime(activeStore.data.fields.work_hours[3].close) }}</li><li v-else>Thursday: Closed</li>
                                <li v-if="isOpen(4)" class="">Friday: {{ formatTime(activeStore.data.fields.work_hours[4].open) }} - {{ formatTime(activeStore.data.fields.work_hours[4].close) }}</li><li v-else>Friday: Closed</li>
                                <li v-if="isOpen(5)" class="">Saturday: {{ formatTime(activeStore.data.fields.work_hours[5].open) }} - {{ formatTime(activeStore.data.fields.work_hours[5].close) }}</li><li v-else>Saturday: Closed</li>
                                <li v-if="isOpen(6)" class="">Sunday: {{ formatTime(activeStore.data.fields.work_hours[6].open) }} - {{ formatTime(activeStore.data.fields.work_hours[6].close) }}</li><li v-else>Sunday: Closed</li>
                            </ul>
                        </div>
                </div>

                <div v-show="activeStore.data.fields.gallery" class="toponym-swiper swiper-container" ref="sliderModal">
                    <div class="swiper-wrapper">
                        <div v-for="( slide, index ) in activeStore.data.fields.gallery" :key="index" class="swiper-slide self-stretch relative flex flex-col" >
                            <img class="object-cover w-full" :src="slide.sizes.toponymslide" :alt="slide.alt">
                        </div>
                    </div>
                </div>
                <a v-show="activeStore.data.fields.cta" :href="activeStore.data.fields.cta.url" :target="activeStore.data.fields.cta.target">VISIT WEBSITE</a>
            </div>
		</ModalWindow> -->
    </section>
</template>


<script>
/* import ModalWindow from "@vuesence/modal-window"; */
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import { format, parseISO } from 'date-fns'
import { zonedTimeToUtc } from 'date-fns-tz'
import getDay from 'date-fns/getDay'
    export default {
        name: 'StoresList',
        /* components: {
            ModalWindow
        }, */
        data() {
            return {
                stores: false,
                categories: false,
                activeCategory: false,
                searchQuery: "",

                showModal: false,
                activeStore: false,
                activeDayHours: false,

                storeCata: null,
                storeCataOptions:{
                    slidesPerView: 5,
                    spaceBetween: 12,
                    navigation: false,
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 12,
                            navigation: false
                        },
                        600: {
                            slidesPerView: 3,
                            spaceBetween: 12,
                            navigation: false
                        }
                    }
                },

                /* MODAL SLIDER */
                sliderModal: null,
                sliderModalOptions: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                    freeMode: true,
                    /* loop: true, */
                    // breakpoints: {
                    //     320: {
                    //         slidesPerView: 2,
                    //         spaceBetween: 0,
                    //         navigation: false
                    //     },
                    //     768: {
                    //         slidesPerView: 4,
                    //         spaceBetween: 24,
                    //     }
                    // }
                },
            }
        },
        mounted() {
            this.getStores()
            this.storeCata = new Swiper( this.$refs.storeCata, this.storeCataOptions )
        },
        computed: {
            filteredStores () {
                let results = this.stores
                if ( this.activeCategory ) {
                    results =  results.filter( store => store.store_category[0] === this.activeCategory.id )
                } else if( this.searchQuery !== "" ) {
                    results = results.filter(store => {
                        let regex = new RegExp('(' +this.searchQuery + ')', 'i');
                        return store.title.rendered.match(regex)
                    })
                    this.updateScroll()
                }
                return results
            }
        },
        methods: {
            updateScroll() {
                /*this.$nextTick(() => {
                    setTimeout(() => {
                        this.$root.scroll.update()
                    }, 200);
                });*/
            },
            getStores() {
                this.getStoresCategories()
                this.$http.get( this.endpoints.rest_base_endpoint  + 'wp/v2/store?per_page=100' )
                    .then( res => {
                        this.stores = res.data
                        this.updateScroll()
                    }
                );
            },
            getStoresCategories() {
                this.$http.get( this.endpoints.rest_base_endpoint  + 'wp/v2/store_category' )
                    .then( res => {
                        this.categories = res.data
                    }
                );
            },
            getNeigbourhoodName(id) {
                let result =  this.neighbourhoodsData.filter(n => n.term_id === id);
                return result[0].name
            },
            openModal(store) {
                this.activeStore = store
                this.activeStore.data.fields.work_hours = Object.values(this.activeStore.data.fields.work_hours)
                this.showModal = true
                this.$nextTick( ()=>{ this.sliderModal = new Swiper( this.$refs.sliderModal, this.sliderModalOptions ) } )
            },
            getDay() {
                let returnStr = ''

                const today = new Date()
                const timeZone = "Europe/Montenegro"
                const utcDate = zonedTimeToUtc(today, timeZone)
                let dayOfWeek = getDay(utcDate)

                switch (dayOfWeek) {
                    case 1: // Monday
                         returnStr = this.activeStore.data.fields.work_hours[0].open + ' - ' + this.activeStore.data.fields.work_hours[0].close
                         this.activeDayHours = this.activeStore.data.fields.work_hours[0]
                         break;
                    case 2: // Tuesday
                         returnStr = this.activeStore.data.fields.work_hours[1].open + ' - ' + this.activeStore.data.fields.work_hours[1].close
                         this.activeDayHours = this.activeStore.data.fields.work_hours[1]
                         break;
                    case 3: // Wednesday
                         returnStr = this.activeStore.data.fields.work_hours[2].open + ' - ' + this.activeStore.data.fields.work_hours[2].close
                         this.activeDayHours = this.activeStore.data.fields.work_hours[2]
                         break;
                    case 4: // Thursday
                         returnStr = this.activeStore.data.fields.work_hours[3].open + ' - ' + this.activeStore.data.fields.work_hours[3].close
                         this.activeDayHours = this.activeStore.data.fields.work_hours[3]
                         break;
                    case 5: // Friday
                        returnStr = this.formatTime(this.activeStore.data.fields.work_hours[4].open) + ' - ' + this.formatTime(this.activeStore.data.fields.work_hours[4].close)
                        this.activeDayHours = this.activeStore.data.fields.work_hours[4]
                        break;
                    case 6: // Saturday
                        returnStr = this.activeStore.data.fields.work_hours[5].open + ' - ' + this.activeStore.data.fields.work_hours[5].close
                        this.activeDayHours = this.activeStore.data.fields.work_hours[5]
                        break;
                    case 0: // Sunday
                        returnStr =  this.formatTime(this.activeStore.data.fields.work_hours[6].open) + ' - ' + this.formatTime(this.activeStore.data.fields.work_hours[6].close)
                        this.activeDayHours = this.activeStore.data.fields.work_hours[6]
                        break;
                    default:
                        returnStr = ""
                }
                return returnStr
            },
            getStatus() {
                if (this.activeDayHours) {
                    let openTime = this.activeDayHours.open
                    let closeTime = this.activeDayHours.close

                    const today = new Date()
                    const timeZone = "Europe/Montenegro"
                    const utcDate = zonedTimeToUtc(today, timeZone)

                    let s =  openTime.split(':');
                    let dt1 = new Date(utcDate.getFullYear(), utcDate.getMonth(), utcDate.getDate(), parseInt(s[0]), parseInt(s[1]), parseInt(s[2]));
                    let e =  closeTime.split(':');
                    let dt2 = new Date(utcDate.getFullYear(), utcDate.getMonth(),utcDate.getDate(), parseInt(e[0]), parseInt(e[1]), parseInt(e[2]));

                    if ( this.activeDayHours.openedclosed ) {
                        return (utcDate >= dt1 && utcDate <= dt2) ?  this.__('Open Now', 'ccave') : this.__('Closed', 'ccave')
                    } else {
                        return this.__('Closed', 'ccave')
                    }
                }

            },
            formatTime(time) {
                const today = new Date()
                const timeZone = "Europe/Montenegro"
                const utcDate = zonedTimeToUtc(today, timeZone)

                let s =  time.split(':');
                let dt1 = new Date(utcDate.getFullYear(), utcDate.getMonth(), utcDate.getDate(), parseInt(s[0]), parseInt(s[1]), parseInt(s[2]));
                return format( dt1, 'hh a')
            },
            isOpen(index) {
                let open = this.activeStore.data.fields.work_hours[index].openedclosed ? true : false
                return open
            },
            getStoreCategory(categoryId) {
                let results = []
                if (this.filteredStores.length > 0) {
                    results = this.categories.find(c => c.id === categoryId)
                }
                return results

            },
            getSearchString() {
                return this.__('Search', 'ccave')
            }
        },
    }
</script>
